import React, { forwardRef, memo } from 'react'
import classNames from "classnames"
import { areEqual } from 'react-window'
import styles from "./IconButton.module.scss"

interface IconButtonProps extends React.PropsWithChildren,
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  className?: string,
  disabled?: boolean
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((
  {
    children,
    className,
    disabled = false,
    ...props
  }: IconButtonProps, ref) => {
  return <button
    ref={ref}
    className={classNames(
      styles.iconButton,
      disabled && styles.disabled,
      className
    )}
    disabled={disabled}
    {...props}
  >{children}</button>
})

IconButton.displayName = "IconButton"
export default memo(IconButton, areEqual)
